module.exports = __webpack_public_path__ + "assets/img/5_1363.7a71ba16.jpg";